import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom"; // Import useLocation
import axios from "axios";
import { toast } from "react-hot-toast";

const Login = () => {
    const [formData, setFormData] = useState({
        email: "",
        password: "",
    });

    const navigate = useNavigate();
    const location = useLocation(); // Initialize useLocation

    // Determine the redirect path: use the previous location state OR default to home
    const from = location.state?.from?.pathname || "/";

    // Handle input changes
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    // Handle form submission
    const handleSubmit = (e) => {
        const id = toast.loading("Logging in...");
        e.preventDefault();
        
        let config = {
            method: "post",
            maxBodyLength: Infinity,
            url: "https://admin.tulikaarts.in/api/login",
            data: formData,
        };

        axios
            .request(config)
            .then((response) => {
                
                // 1. Save Token and Profile Data
                window.localStorage.setItem("token", response.data.token);
                if (response.data.client) {
                    window.localStorage.setItem("clientProfile", JSON.stringify(response.data.client));
                }

                toast.success("Login Successful!", { id });
                
                // 2. ⭐ CORRECTION: CONDITIONAL NAVIGATION
                // Redirects to the 'from' path (e.g., /cart) or to the home page (/)
                navigate(from, { replace: true }); 
                
            })
            .catch((error) => {
                console.error(error);
                const responseData = error.response?.data;

                // Enhanced Error Handling
                if (responseData?.errors) {
                    const errorMsg = Array.isArray(responseData.errors) ? responseData.errors[0] : responseData.errors;
                    toast.error(errorMsg, { id });
                } else if (responseData?.message) {
                    toast.error(responseData.message, { id });
                } else {
                    toast.error("Login failed. Please check your credentials.", { id });
                }
            });
    };

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <h2>Login</h2>
                <form onSubmit={handleSubmit}>
                    <div style={styles.formGroup}>
                        <label htmlFor="email">Email:</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            style={styles.input}
                        />
                    </div>
                    <div style={styles.formGroup}>
                        <label htmlFor="password">Password:</label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            required
                            style={styles.input}
                        />
                    </div>
                    <div style={{ textAlign: "right", marginBottom: "15px" }}>
                        <Link to="/forgot_password">Forgot Password?</Link>
                    </div>
                    <button type="submit" style={styles.button}>
                        Login
                    </button>
                </form>
                <p>
                    Don't have an account? <Link to="/signup">Sign Up</Link>
                </p>
            </div>
        </div>
    );
};

const styles = {
    container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#f4f4f4",
    },
    card: {
        background: "#fff",
        padding: "20px",
        borderRadius: "8px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        width: "450px",
        textAlign: "center",
    },
    formGroup: {
        marginBottom: "15px",
        textAlign: "left",
    },
    input: {
        width: "100%",
        padding: "10px",
        border: "1px solid #ccc",
        borderRadius: "4px",
    },
    button: {
        width: "100%",
        padding: "10px",
        border: "none",
        borderRadius: "4px",
        backgroundColor: "#cc9051",
        color: "white",
        fontSize: "18px",
        fontWeight: "500",
        cursor: "pointer",
    },
};

export default Login;